import { render, staticRenderFns } from "./CompletedStatuses.vue?vue&type=template&id=e55346b4&"
import script from "./CompletedStatuses.vue?vue&type=script&lang=js&"
export * from "./CompletedStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports